function subscriptionActionService(subscriptionStateService, billingService, f) {
    var MONTHLY = 'month';
    var YEARLY = 'year';

    function isOnTrial() {
        return subscriptionStateService.getState().then(function(state) {
            return state.isOnTrial;
        });
    }

    function canTrial() {
        return subscriptionStateService.getState().then(function(state) {
            return state.canTrial;
        });
    }

    function shouldSubscribe() {
        return subscriptionStateService.getState().then(function(state) {
            return state.shouldSubscribe;
        });
    }

    function shouldRenew() {
        return subscriptionStateService.getState().then(function(state) {
            return state.shouldRenew;
        });
    }

    function canRenewPlanTo(from, to) {
        return from.interval !== YEARLY || to.interval !== MONTHLY;
    }

    function canChangePlanTo(from, to) {
        return from.interval !== to.interval && canRenewPlanTo(from, to);
    }

    function canChangePlan() {
        return billingService.getActiveSubscription()
            .then(function(subscription) {
                return billingService.getAvailablePlans().then(function(plans) {
                    return !!subscription && !subscription.cancel_at_period_end && plans.filter(f.curry(canChangePlanTo)(subscription.plan)).length > 0;
                });
            });
    }

    return {
        isOnTrial: isOnTrial,
        shouldSubscribe: shouldSubscribe,
        shouldRenew: shouldRenew,
        canRenewPlanTo: canRenewPlanTo,
        canChangePlanTo: canChangePlanTo,
        canChangePlan: canChangePlan,
        canTrial: canTrial
    };
}

angular.module('ikeweb.subscription').factory('subscriptionActionService', ['subscriptionStateService', 'billingService', 'functional', subscriptionActionService]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/subscription/subscription.action.service.js
// module id = 409
// module chunks = 0